import { OrdersModel } from '@pukka/api';
import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

type OrderGratuity = OrdersModel.OrderGratuity & { finalAmount: number };

interface RefundGratuityProps {
  readonly paymentGratuities?: OrderGratuity[];
  readonly includeGratuityTax?: OrdersModel.OrderDetail['include_gratuity_tax'];
}

function RefundGratuity({ paymentGratuities, includeGratuityTax }: RefundGratuityProps) {
  const showGratuity = paymentGratuities?.some((gratuity) => gratuity.finalAmount !== 0);

  if (showGratuity) {
    return (
      <div className="mb-4">
        <Text weight="semibold" className="py-2">
          Gratuity
        </Text>
        {paymentGratuities?.map((gratuity, idx) => {
          return (
            <div key={idx} className="flex justify-between border-t py-2">
              <Text>
                {gratuity.name} {includeGratuityTax && '(Included)'}
              </Text>
              <Text>{!includeGratuityTax && numberUtils.formatCurrency(gratuity.finalAmount, 'Rp.')}</Text>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
}

export default RefundGratuity;
